/**
 * PM CRM utility functions.
 * Moved from _base.html <script> block into the bundle.
 */

// Next action date save callback — optimistic update of the trigger label so
// the cell reflects the new date without re-rendering the row.
// Dropdown close is handled declaratively via data-success-close-dropdown on the form.
window.pmCrmNextActionSaved = function(form, event) {
    if (!event.detail.successful) return;
    // The form stays in the DOM (hx-swap="none"), and remarks are a one-time
    // note logged with this save — clear them so the next save can't repeat them.
    var remarksInput = form.querySelector('[name=remarks]');
    if (remarksInput) remarksInput.value = '';
    var dateInput = form.querySelector('[name=next_action_date]');
    var actionInput = form.querySelector('[name=next_action]');
    var compactDisplayId = form.getAttribute('data-next-action-display-id');
    var compactDisplay = compactDisplayId && document.getElementById(compactDisplayId);
    var val = dateInput ? dateInput.value : '';
    if (compactDisplay) {
        var dateNode = compactDisplay.querySelector('[data-next-action-date]');
        var actionNode = compactDisplay.querySelector('[data-next-action-action]');
        var today = new Date();
        var todayValue = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
        var isToday = val && val === todayValue;
        var isOverdue = val && val < todayValue;
        var dateLabel = val
            ? (isToday ? 'Today' : new Date(val + 'T12:00:00').toLocaleDateString('en-US', {month: 'short', day: 'numeric'}))
            : '\u2014';
        var actionLabel = actionInput && actionInput.value.trim();
        if (actionLabel && actionLabel.length > 24) actionLabel = actionLabel.slice(0, 23) + '\u2026';
        if (dateNode) {
            dateNode.textContent = dateLabel;
            dateNode.classList.toggle('data-table__status', isToday || isOverdue);
            dateNode.classList.toggle('data-table__status--warning', isToday);
            dateNode.classList.toggle('data-table__status--error', isOverdue);
        }
        if (actionNode) {
            actionNode.textContent = actionLabel ? ' ' + actionLabel : '';
            actionNode.hidden = !actionLabel;
            actionNode.classList.toggle('data-table__muted', !!actionLabel);
        }
        return;
    }
    var dropdown = form.closest('.dropdown');
    if (!dropdown) return;
    var trigger = dropdown.querySelector('[data-dropdown]');
    if (!trigger) return;
    trigger.textContent = val
        ? new Date(val + 'T12:00:00').toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
        : '\u2014';
};

// Fills the button's form's date input (`data-quick-date-target` names it; default
// next_action_date) with the browser's local date `days` from today.  `btn.form`
// covers a button joined to its form by the `form` attribute.  Local, not
// toISOString(): that is UTC, which is already tomorrow on a US evening.
function isoDate(d) {
    var pad = function(n) { return String(n).padStart(2, '0'); };
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

// `data-quick-date-from` names another date input in the form to count from
// when it is filled (a listing's Expires counts from its listing date).
// `data-quick-date-business` moves a Saturday or Sunday to the next Monday
// (a contract's close of escrow).  Holidays are not skipped.
window.pmCrmSetQuickDate = function(btn, days) {
    var form = btn.form || btn.closest('form');
    var fromName = btn.getAttribute('data-quick-date-from');
    var from = fromName && form.querySelector('[name="' + fromName + '"]');
    var d = from && from.value ? new Date(from.value + 'T12:00:00') : new Date();
    d.setDate(d.getDate() + days);
    if (btn.hasAttribute('data-quick-date-business')) {
        if (d.getDay() === 6) d.setDate(d.getDate() + 2);
        else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    var val = isoDate(d);
    var name = btn.getAttribute('data-quick-date-target') || 'next_action_date';
    form.querySelector('[name="' + name + '"]').value = val;
};

// Acqs snooze menu presets (`_acq_snooze_menu.html`), dated from the browser's
// today to match `_snooze_presets`: next Monday, and the 1st of next month.
function snoozePresetDate(key) {
    var d = new Date();
    if (key === 'tomorrow') d.setDate(d.getDate() + 1);
    else if (key === 'next-week') d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7));
    else if (key === 'two-weeks') d.setDate(d.getDate() + 14);
    else if (key === 'next-month') d = new Date(d.getFullYear(), d.getMonth() + 1, 1);
    return d;
}

window.acqSnoozeDate = function(key) { return isoDate(snoozePresetDate(key)); };

// Re-label each preset with its browser date as its menu opens (capture phase,
// before dropdowns.js shows it), and hide Next week when that Monday is tomorrow.
document.addEventListener('click', function(e) {
    var toggle = e.target && e.target.closest && e.target.closest('[data-dropdown]');
    var dropdown = toggle && toggle.closest('.dropdown');
    if (!dropdown) return;
    var tomorrow = window.acqSnoozeDate('tomorrow');
    dropdown.querySelectorAll('[data-snooze-preset]').forEach(function(item) {
        var key = item.getAttribute('data-snooze-preset');
        var label = item.querySelector('[data-snooze-date]');
        if (label) label.textContent = snoozePresetDate(key).toLocaleDateString('en-US', {weekday: 'short', month: 'short', day: 'numeric'});
        item.hidden = key === 'next-week' && window.acqSnoozeDate(key) === tomorrow;
    });
}, true);

// Activity log filter — shows/hides log entries by type, re-applies clamp
// Works on any card with [data-log-card] — falls back to #activity-card for legacy callers.
// Log list is found via [data-log-list] on the list element, falling back to #log-list.
function filterLogEntries(btn, type) {
    var card = btn.closest('[data-log-card]') || btn.closest('#activity-card');
    if (!card) return;
    card.querySelectorAll('[data-log-filter]').forEach(function(b) { b.classList.remove('chip-active'); });
    btn.classList.add('chip-active');
    var logList = card.querySelector('[data-log-list]') || card.querySelector('#log-list');
    if (logList) {
        logList.querySelectorAll(':scope > [data-log-type]').forEach(function(el) {
            el.style.display = (type === 'all' || el.getAttribute('data-log-type') === type) ? '' : 'none';
        });
    }
    var list = card.querySelector('[data-clamp-list]');
    if (list && window._cc && window._cc.applyClampList) window._cc.applyClampList(list);
}

// Keep global for any remaining callers
window.filterLogEntries = filterLogEntries;

// A list swapped in under the pills (the offer page's Activity entries refresh in place)
// comes back unfiltered; re-apply each card's active pill.
document.addEventListener('htmx:afterSettle', function() {
    document.querySelectorAll('[data-log-card] [data-log-filter].chip-active:not([data-log-filter="all"])').forEach(function(pill) {
        filterLogEntries(pill, pill.getAttribute('data-log-filter'));
    });
});

// Delegated click handler for [data-log-filter] buttons
document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-log-filter]');
    if (!btn) return;
    filterLogEntries(btn, btn.getAttribute('data-log-filter'));
});

// Delegated click handler for [data-quick-date] buttons
document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-quick-date]');
    if (!btn) return;
    var days = parseInt(btn.getAttribute('data-quick-date'), 10);
    window.pmCrmSetQuickDate(btn, days);
});

// Delegated click handler for [data-quick-value] buttons: fills the input named
// by `data-quick-value-target` in the button's form (commission 2% / 3%, a Work task's waiting-on picks) and
// fires input and change on it.  With `data-quick-value-toggle` the chips act as one pick: the picked chip is
// `chip-primary`, the rest `chip-muted`, and clicking the picked chip clears the input (a buyer lead's waiting on).
document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-quick-value]');
    if (!btn) return;
    var target = btn.getAttribute('data-quick-value-target');
    var form = btn.form || btn.closest('form');
    var input = form && form.querySelector('[name="' + target + '"]');
    if (!input) return;
    var value = btn.getAttribute('data-quick-value');
    if (btn.hasAttribute('data-quick-value-toggle')) {
        if (input.value === value) value = '';
        form.querySelectorAll('[data-quick-value-toggle][data-quick-value-target="' + target + '"]').forEach(function(chip) {
            var picked = chip.getAttribute('data-quick-value') === value;
            chip.classList.toggle('chip-primary', picked);
            chip.classList.toggle('chip-muted', !picked);
            chip.setAttribute('aria-pressed', picked ? 'true' : 'false');
        });
    }
    input.value = value;
    // Tell listeners on the input, as typing would.
    input.dispatchEvent(new Event('input', {bubbles: true}));
    input.dispatchEvent(new Event('change', {bubbles: true}));
});

// Follow up chips under an acqs comment box: one picked at a time, a second
// click clears it.  The chips sit outside the form and join it through their
// `form` attribute; the picked chip's date rides along in the form's hidden
// next_action_date, and an empty one saves a plain comment.
function followUpChips(form) {
    return form.id ? document.querySelectorAll('[data-follow-up-days][form="' + form.id + '"]') : [];
}

function clearFollowUpChips(form) {
    followUpChips(form).forEach(function(c) { c.classList.remove('chip-active'); });
    var input = form.querySelector('input[name="next_action_date"]');
    if (input) input.value = '';
}

document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('[data-follow-up-days]');
    if (!chip || !chip.form) return;
    var form = chip.form;
    var wasActive = chip.classList.contains('chip-active');
    clearFollowUpChips(form);
    if (wasActive) return;
    chip.classList.add('chip-active');
    window.pmCrmSetQuickDate(chip, parseInt(chip.getAttribute('data-follow-up-days'), 10));
});

document.addEventListener('reset', function(e) {
    if (e.target.tagName === 'FORM' && followUpChips(e.target).length) {
        clearFollowUpChips(e.target);
    }
});

// Textareas with [data-autoresize] only re-measure on `input` / form `reset`;
// assigning .value directly fires neither, so re-measure explicitly.
function resizeNextAction(el) {
    if (el && window._cc && window._cc.autoResize) window._cc.autoResize(el);
}

document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var valueBtn = e.target.closest('[data-next-action-value]');
    var clearDateBtn = e.target.closest('[data-clear-next-action-date]');
    var clearActionBtn = e.target.closest('[data-clear-next-action]');
    var btn = valueBtn || clearDateBtn || clearActionBtn;
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;
    if (valueBtn) {
        var nextAction = form.querySelector('textarea[name=next_action]');
        if (nextAction) {
            nextAction.value = valueBtn.getAttribute('data-next-action-value') || '';
            resizeNextAction(nextAction);
        }
    }
    if (clearDateBtn) {
        var dateInput = form.querySelector('input[name=next_action_date]');
        if (dateInput) dateInput.value = '';
    }
    if (clearActionBtn) {
        var textarea = form.querySelector('textarea[name=next_action]');
        if (textarea) {
            textarea.value = '';
            resizeNextAction(textarea);
        }
    }
});
